import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import createComponent from 'components/core/createComponent';
import { defaultsDeep } from 'lodash';
import JBImage from 'components/essentials/JBImage';
import container from './container';
const ImageHalfTextLeft = props => {
  const $ = _c(17);
  let t0;
  if ($[0] !== props.config) {
    t0 = defaultsDeep(props.config, {
      "main-image": {
        options: {}
      },
      "main-title": {
        options: {}
      }
    });
    $[0] = props.config;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const configWithDefaults = t0;
  const t1 = configWithDefaults["main-subtitle"].value || null;
  let t2;
  if ($[2] !== t1) {
    t2 = <h2 className="text-xs font-bold tracking-[.04em] text-gray mt-0 mx-0 mb-[.4rem] uppercase" data-name="main-subtitle" data-xc="main-subtitle">{t1}</h2>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = configWithDefaults["main-title"].value || null;
  let t4;
  if ($[4] !== t3) {
    t4 = <h1 className="text-[2.375rem] leading-[2.375rem] tracking-[-.02em] mt-0 mx-0 mb-[1.1rem] font-normal text-gray" data-name="main-title" data-xc="main-title">{t3}</h1>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = configWithDefaults["main-text"].value || null;
  let t6;
  if ($[6] !== t5) {
    t6 = <p className="font-normal text-gray text-base leading-[1.5rem]">{t5}</p>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6) {
    t7 = <div className="basis-full sm:basis-1/3 min-w-0 h-[65vh] flex flex-col justify-center px-16 py-8 max-[1200px]:p-8">{t2}{t4}{t6}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = configWithDefaults["left-image"].value || null;
  let t9;
  if ($[12] !== t8) {
    t9 = <div className="min-sm:basis-[66.66667%] min-sm:min-w-0 basis-full min-w-0 "><div className="h-[65vh] media media-img [&_img]:h-full [&_img]:w-full [&_img]:object-cover"><JBImage src={t8} data-left="left-image" data-xc="left-image" /></div></div>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <div data-xc="D-M1" className="flex flex-wrap flex-row items-stretch">{t7}{t9}</div>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
ImageHalfTextLeft.propTypes = {
  config: PropTypes.object
};
export default createComponent(ImageHalfTextLeft, container);